import { render } from "./notifier.vue?vue&type=template&id=9a7db286"
import script from "./notifier.vue?vue&type=script&lang=js"
export * from "./notifier.vue?vue&type=script&lang=js"

import "./notifier.vue?vue&type=style&index=0&id=9a7db286&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__